const ja = {
  seo: {
    title: "画像からQRコードを読み取る｜無料オンライン",
    description:
      "スクリーンショットや保存画像を選ぶだけで、QRコードの内容をブラウザ上で確認できます。iPhone、Android、LINEでの読み取り方も解説します。",
    keywords:
      "QRコード 画像 読み取り, QRコード 読み取り オンライン, スクリーンショット QRコード, パソコン QRコード 読み取り, iPhone QRコード, Android QRコード"
  },
  ui: {
    home: "ホーム",
    highlights: "特長",
    idleTitle: "読み取り結果がここに表示されます",
    idleDescription: "画像を選ぶとQRコードの読み取りが始まります。",
    errorTitle: "QRコードを読み取れませんでした",
    backToScanner: "読み取りツールへ戻る ↑",
    faqEyebrow: "よくある質問"
  },
  breadcrumb: "画像からQRコードを読み取る",
  eyebrow: "画像用QRコード読み取りツール",
  title: "画像からQRコードを読み取る",
  intro:
    "画像やカメラからQRコードを読み取る. 結果はポップアップに表示されます。内容をコピーするか、有効なHTTP・HTTPSのURLの場合は「リンクを開く」を押してください。",
  benefits: [
    "専用アプリのインストール不要",
    "画像は端末内で処理",
    "QRコードの内容"
  ],
  tool: {
    title: "QRコードが写った画像を選択",
    description:
      "QRコードの四辺と周囲の余白が見える、鮮明な元画像またはスクリーンショットを使用してください。",
    dropTitle: "QRコード画像をここにドロップ",
    dropActiveTitle: "画像を離すと読み取りを開始します",
    dropDescription: "またはスマートフォン・パソコンから画像を選択",
    chooseFile: "画像を選択",
    fileHint: "PNG、JPG、JPEG、WebPに対応・最大12MB",
    privacy:
      "画像はこのブラウザ内で処理され、QRCode GENのサーバーには送信されません。",
    processing: "QRコードを読み取っています…",
    resultTitle: "QRコードの内容",
    resultType: "内容の種類",
    copy: "コピー",
    copied: "コピーしました",
    openLink: "リンクを開く",
    scanAnother: "別の画像を読み取る",
    previewAlt: "選択したQRコード画像",
    idleTabTitle: "QRコードを読み取り中…",
    idleTabMessage: "QRコードの内容を読み取っています…",
    noResult:
      "画像内にQRコードが見つかりませんでした。コード全体と周囲の余白が写った、より鮮明な画像でお試しください。",
    invalidType: "PNG、JPG、JPEG、WebPの画像を選択してください。",
    tooLarge: "画像が12MBを超えています。ファイルサイズを小さくしてから、もう一度お試しください。",
    imageError: "画像を開けませんでした。PNGまたはJPGで保存し直してからお試しください。",
    copyError: "自動でコピーできませんでした。下の内容を選択してコピーしてください。",
    safety:
      "QRCode GENはリンク先の安全性を確認しないため、パスワードや認証コード、決済情報を入力する前にドメインを確認してください。",
    types: {
      url: "Webサイトのリンク",
      wifi: "Wi-Fi接続情報",
      email: "メール",
      phone: "電話番号",
      sms: "SMS",
      vcard: "vCard連絡先",
      payment: "決済データ",
      text: "テキスト"
    }
  },
  onlineGuide: {
    eyebrow: "QRCode GENでそのまま読み取り",
    title: "画像内のQRコードを読み取る方法",
    intro:
      "メール、PDF、スクリーンショットなど、今使っている端末内にQRコードがあるときに便利です。",
    visual: {
      alt: "QRコード画像をブラウザで読み取り、結果を確認する3ステップ",
      source: "QRコード画像",
      process: "ブラウザで解析",
      result: "結果を確認"
    },
    steps: [
      {
        number: "01",
        title: "コード全体が写った画像を用意",
        description:
          "3つの大きな切り出しシンボルと周囲の余白を残します。ぼけた画像や強く圧縮された画像は避けてください。"
      },
      {
        number: "02",
        title: "画像を選択またはドロップ",
        description:
          "上の欄に画像を追加します。ブラウザ内で処理するため、カメラや読み取り専用アプリは不要です。"
      },
      {
        number: "03",
        title: "読み取った内容を確認",
        description:
          "結果はポップアップに表示されます。内容をコピーするか、有効なHTTP・HTTPSのURLの場合は「リンクを開く」を押してください。"
      },
      {
        number: "04",
        title: "コピーまたは別の画像を読み取り",
        description:
          "内容をコピーして使うか、URLを確認してからリンクを開いてください。結果の画面を閉じると、読み取り画面に戻れます。"
      }
    ]
  },
  deviceGuides: [
    {
      id: "scan-qr-code-iphone",
      icon: "mobile",
      eyebrow: "iOS・iPhoneとiPad",
      title: "iPhoneでQRコードを読み取る方法",
      description:
        "標準のカメラまたはコントロールセンターの「コードスキャナー」を使えます。",
      steps: [
        "ホーム画面、ロック画面、コントロールセンターからカメラを開きます。",
        "写真モードで、QRコード全体が画面内に収まるように端末を向けます。",
        "画面にリンクや通知が表示されたら、内容を確認してタップします。",
        "コードスキャナーがない場合は、コントロールセンターに追加して使用します。"
      ],
      note:
        "同じiPhoneに保存した画像なら、別の端末を用意せず、上のツールへアップロードして読み取れます。",
      visual: {
        type: "iphone",
        alt: "iPhoneのカメラがQRコードを認識し、リンクを表示する様子",
        app: "カメラ",
        status: "リンクを認識しました",
        caption: "QRコード全体を画面に収め、表示されたリンクをタップします。"
      }
    },
    {
      id: "scan-qr-code-android",
      icon: "globe",
      eyebrow: "Android",
      title: "AndroidでQRコードを読み取る方法",
      description:
        "端末メーカー、Androidのバージョン、カメラアプリによって操作が異なります。",
      steps: [
        "カメラを写真モードで開き、QRコードへ向けます。バナーが表示されたらタップします。",
        "認識しない場合は、カメラ、Googleフォト、GoogleアプリからGoogleレンズを開きます。",
        "Samsung Galaxyでは、カメラまたはクイック設定の「QRコードをスキャン」も確認します。",
        "保存画像はギャラリーやGoogleフォトで開いてレンズを使うか、このページへ追加します。"
      ],
      note:
        "Camera from GoogleのQR読み取りは一部端末のみ対応しています。ボタン名や場所はメーカーによって異なります。",
      visual: {
        type: "android",
        alt: "AndroidスマートフォンでGoogleレンズからQRコードを読み取る様子",
        app: "Googleレンズ",
        status: "タップして開く",
        caption: "標準カメラで認識しない場合は、Googleレンズや端末のQR読み取り機能を試します。"
      }
    },
    {
      id: "scan-qr-code-social-apps",
      icon: "message",
      eyebrow: "LINE・SNS・決済アプリ",
      title: "LINEなどのアプリでQRコードを読み取る方法",
      description:
        "アプリ内のスキャナーは便利ですが、対応するQRコードの種類はアプリごとに異なります。",
      steps: [
        "LINEでは、友だち追加用QRコードのほか、URLやテキストなども読み取れます。",
        "LINEの読み取り画面で画像アイコンを選ぶと、保存画像内のQRコードを確認できます。",
        "SNSのスキャナーは、自社サービスのプロフィールやログイン用コードを優先する場合があります。",
        "決済用QRコードは対応する決済・銀行アプリで読み取り、支払先と金額を確認します。"
      ],
      note:
        "アプリで認識しない場合でも、QRコードが壊れているとは限りません。カメラ、Googleレンズ、上の画像ツールをお試しください。",
      visual: {
        type: "social",
        alt: "LINE、SNS、決済アプリにあるQRコード読み取り機能",
        app: "アプリ内スキャナー",
        status: "コードに合ったアプリを選択",
        labels: ["LINE", "SNS", "決済"],
        caption: "アプリによって読み取れるQRコードの種類が異なります。"
      }
    },
    {
      id: "other-qr-code-scanners",
      icon: "qrcode",
      eyebrow: "ほかの読み取り方法",
      title: "カメラでQRコードを読み取れないときは？",
      description:
        "知らない読み取りアプリを入れる前に、端末にある機能やブラウザツールを試します。",
      steps: [
        "一方の画面にQRコードを表示し、別のスマートフォンのカメラで読み取ります。",
        "画像を保存またはスクリーンショットし、QRCode GENへ追加します。",
        "Googleレンズや写真アプリにあるQRコード認識機能を使います。",
        "アプリが必要な場合は公式ストアから入手し、要求される権限を確認します。"
      ],
      note:
        "店舗用バーコードリーダーは2次元コード対応が必要です。1次元バーコード専用機ではQRコードを読み取れません。",
      visual: {
        type: "alternatives",
        alt: "パソコンで保存画像内のQRコードを読み取る様子",
        app: "保存画像",
        status: "QRコードの内容",
        caption: "鮮明な画像またはスクリーンショットを保存し、上のツールへ追加します。"
      }
    }
  ],
  troubleshooting: {
    eyebrow: "画像を認識しないとき",
    title: "画像内のQRコードを読み取れない主な原因",
    items: [
      {
        title: "コードの端や余白が切れている",
        description:
          "3つの大きな切り出しシンボルと、周囲の明るい余白がすべて写った画像を使用します。"
      },
      {
        title: "大きな画像の中でQRコードが小さすぎる",
        description:
          "コードを切らないように不要な部分だけをトリミングし、高画質で保存してから試します。"
      },
      {
        title: "ぼけ、強い圧縮、光の反射がある",
        description:
          "元画像を使うか、近くから撮り直します。別画面を撮る場合は画面の明るさも調整します。"
      },
      {
        title: "印刷サイズに対してパターンが細かすぎる",
        description:
          "長いURL、多項目のvCard、長文は密度を高めます。情報を減らすか、短縮URLや動的QRコードを使います。"
      },
      {
        title: "1枚の画像にQRコードが複数ある",
        description:
          "読み取りたいコードの周辺だけを切り出します。このツールは最初に認識した1件を表示します。"
      },
      {
        title: "URLは読めたのにリンク先を開けない",
        description:
          "QRコード自体は正常な場合があります。通信、URLの表記、ファイルの公開範囲、ページの有効性を確認します。"
      }
    ]
  },
  safety: {
    eyebrow: "開いた後も確認",
    title: "読み取れるQRコードが安全とは限りません",
    description:
      "QRコードは情報を格納する仕組みです。正しいURLでも、偽のログイン画面や不審なダウンロード先へつながる可能性があります。",
    checks: [
      "ドメイン全体を読み、企業名に似せた文字がないか確認する",
      "確認できないサイトへパスワードや認証コードを入力しない",
      "公式ストア以外からアプリやファイルをインストールしない",
      "決済時はアプリ上の支払先、金額、通貨を確認する"
    ]
  },
  faq: {
    eyebrow: "よくある質問",
    title: "画像からのQRコード読み取りに関する質問",
    items: [
      {
        q: "QRコード画像はサーバーへ送信されますか？",
        a: "送信されません。画像の画素は端末のブラウザ内で処理されます。QRCode GENのサーバーへ画像をアップロードせずに読み取ります。"
      },
      {
        q: "スクリーンショットから読み取れますか？",
        a: "コード全体が鮮明に写っていれば読み取れます。画面全体の中で小さい場合は、周囲の余白を残して近くまでトリミングしてください。"
      },
      {
        q: "対応する画像形式は？",
        a: "PNG、JPG、JPEG、WebPに対応し、最大12MBです。HEICはJPGまたはPNGへ変換してから追加してください。"
      },
      {
        q: "鮮明に見えるのに読み取れない理由は？",
        a: "周囲の余白不足、ゆがみ、低いコントラスト、小さな画像に対する高すぎる情報密度が考えられます。元画像や高解像度の画像でお試しください。"
      },
      {
        q: "決済用QRコードも読み取れますか？",
        a: "文字列を表示できる場合はありますが、支払先の確認や決済は行いません。対応する決済・銀行アプリで再度読み取り、支払先と金額を確認してください。"
      },
      {
        q: "URLを読めたのに新しいタブが開かないのはなぜですか？",
        a: "ブラウザのポップアップ設定で止められる場合があります。結果欄の「リンクを開く」を押し、通信やリンク先の公開状態も確認してください。"
      }
    ]
  },
  relatedTitle: "関連ページ",
  relatedLinks: [
    { href: "/help", label: "カメラでQRコードを認識しないときの対処法" },
    { href: "/products/short-link", label: "長いURLを短くして読み取りやすくする" },
    { href: "/products/custom-qr-code", label: "読み取りやすさを保ってデザインする" },
    { href: "/what-is-qr-code", label: "QRコードの仕組みを知る" }
  ],
  cta: {
    title: "新しいQRコードを作成しますか？",
    description:
      "内容の種類を選び、入力情報を確認してから、ブラウザ上で作成・ダウンロードできます。",
    href: "/",
    label: "無料でQRコードを作成"
  }
};

export default ja;
